// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"card_3qLaA","card__carousel":"card__carousel_3F4O3","card__labels":"card__labels_1B9LD","card__summary":"card__summary_2mT3j"};